import { Api } from '@/api/api';
import { ClientDuplicateRequestFilters } from '@/api/requests/manage-duplicates/client-duplicate-request-filters';
import { ManageClientDuplicateRequestFilters } from '@/api/requests/manage-duplicates/manage-client-duplicate-request-filters';
import { ClientAccountDuplicate } from '@/shared/clients/client-account-duplicate';
import { ClientAccount } from '../shared/clients/client-account';

export class ManageDuplicateApi extends Api {
    public getDuplicateClientsAsync(filters: ManageClientDuplicateRequestFilters): Promise<Array<ClientAccount>> {
        return this.getAsync<Array<ClientAccount>>(`v1/manageDuplicate`, filters);
    }

    public getDuplicateClientsByIdAsync(clientId: string, filters: ClientDuplicateRequestFilters): Promise<Array<ClientAccountDuplicate>> {
        return this.getAsync<Array<ClientAccountDuplicate>>(`v1/manageDuplicate/${clientId}`, filters);
    }

    public constructor() {
        super();
    }
}
